import React, { useEffect, useState } from 'react'

const Confetti = () => {
  const [confetti, setConfetti] = useState([])

  useEffect(() => {
    // Create confetti pieces
    const colors = ['#10b981', '#3b82f6', '#f59e0b', '#ef4444', '#8b5cf6', '#06b6d4']
    const pieces = []
    
    for (let i = 0; i < 50; i++) {
      pieces.push({
        id: i,
        x: Math.random() * 100,
        y: -10,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * 360,
        size: Math.random() * 8 + 4,
        speed: Math.random() * 3 + 2
      })
    }
    
    setConfetti(pieces)

    // Animate confetti
    const interval = setInterval(() => {
      setConfetti(prev => 
        prev.map(piece => ({
          ...piece,
          y: piece.y + piece.speed,
          rotation: piece.rotation + 5
        })).filter(piece => piece.y < 110)
      )
    }, 50)

    // Clean up after 5 seconds
    const timeout = setTimeout(() => {
      clearInterval(interval)
      setConfetti([])
    }, 5000)

    return () => {
      clearInterval(interval)
      clearTimeout(timeout)
    }
  }, [])

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {confetti.map(piece => (
        <div
          key={piece.id}
          className="absolute w-2 h-2 rounded-sm"
          style={{
            left: `${piece.x}%`,
            top: `${piece.y}%`,
            backgroundColor: piece.color,
            transform: `rotate(${piece.rotation}deg)`,
            width: `${piece.size}px`,
            height: `${piece.size}px`
          }}
        />
      ))}
    </div>
  )
}

export default Confetti
